export default ($store, $route) => {
  const pin = $store.getters['Acacia/Models/PIN/Get'];

  if ($route && $route.query && $route.query.redirect) {
    const redirect = $route.query.redirect.replace(/^.*:\/\//, '');
    window.location.replace(`${pin.protocol}://${redirect}`);
  } else {
    const domain = $store.getters['Acacia/Utils/Domain'];
    window.location.href = `${pin.protocol}://access.${domain}`;
  }
};



// WEBPACK FOOTER //
// ./src/services/redirect.js